import PlaylistSearchTileV1 from './PlaylistSearchTileV1'

export default PlaylistSearchTileV1
